<template>
  <header
    class="main"
    data-element="header"
    @keydown.esc="setMobileMenuStatus(false)"
    :class="{
      'nav-down': headerDown,
      'nav-up': headerUp,
      'nav-small': headerSmall,
    }"
  >
    <div
      class="container d-flex align-items-center"
      itemscope="itemscope"
      itemtype="http://www.schema.org/SiteNavigationElement"
    >
      <router-link
        itemprop="url"
        :to="{ name: 'home' }"
        title="ito Startseite"
        alt="ito consult GmbH"
        class="d-block logo"
      >
        <span itemprop="name" class="d-none">Startseite</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 522.6 291.6"
          height="40"
        >
          <path
            d="M37.2,135.6V291.4H88V135.6S62.6,147.3,37.2,135.6Z"
            style="fill: #3c3c3b"
          />
          <path
            d="M437.9,37.3H135.2s10.7,24.9.2,50.7l17.4.1V291.4h50.8V88h69.25q-4.34,14.84-4.35,34v84.7q0,84.71,84.7,84.7v.2l84.7-.2q84.71-.25,84.7-84.7V122Q522.65,37.3,437.9,37.3Zm33.9,160.9c0,28.3-14.2,42.4-42.4,42.4H361.7c-28.3,0-42.4-14.2-42.4-42.4V130.4Q319.3,88,353.2,88h76.2c28.3,0,42.4,14.2,42.4,42.4Z"
            style="fill: #3c3c3b"
          />
          <circle cx="62.3" cy="62.3" r="62.3" style="fill: #e30613" />
        </svg>
      </router-link>
      <nav
        class="ms-auto navigation-main d-lg-block px-5 px-lg-0"
        :class="{ is_active: mobileMenuStatus }"
      >
        <ul class="d-lg-flex flex-wrap align-items-center no-style">
          <li class="my-4 my-lg-0 position-relative">
            <router-link
              itemprop="url"
              @click.native="setMobileMenuStatus(false)"
              class="px-4 py-1"
              :to="{ name: 'ito' }"
              title="ito Wir"
              ><span itemprop="name">Wir</span></router-link
            >
            <ul class="sub no-style py-2 py-lg-4">
              <li>
                <router-link
                  itemprop="url"
                  @click.native="setMobileMenuStatus(false)"
                  class="px-4 py-1"
                  :to="{ name: 'ito.team' }"
                  title="ito Team"
                  ><span itemprop="name">Team</span></router-link
                >
              </li>
              <li>
                <router-link
                  itemprop="url"
                  @click.native="setMobileMenuStatus(false)"
                  class="px-4 py-1"
                  :to="{ name: 'ito.philosophy' }"
                  title="ito Philosophie"
                  ><span itemprop="name">Philosophie</span></router-link
                >
              </li>
              <li>
                <router-link
                  itemprop="url"
                  @click.native="setMobileMenuStatus(false)"
                  class="px-4 py-1"
                  :to="{ name: 'ito.history' }"
                  title="ito Historie"
                  ><span itemprop="name">Historie</span></router-link
                >
              </li>
              <li>
                <router-link
                  itemprop="url"
                  @click.native="setMobileMenuStatus(false)"
                  class="px-4 py-1"
                  :to="{ name: 'ito.partner' }"
                  title="ito Partner"
                  ><span itemprop="name">Partner</span></router-link
                >
              </li>
            </ul>
          </li>
          <li class="position-relative my-4 my-lg-0">
            <router-link
              itemprop="url"
              @click.native="setMobileMenuStatus(false)"
              class="px-4 py-1"
              :to="{ name: 'services' }"
              title="Leistungen der ito"
              ><span itemprop="name">Leistungen</span></router-link
            >
            <ul class="sub no-style py-2 py-lg-4">
              <li>
                <router-link
                  itemprop="url"
                  @click.native="setMobileMenuStatus(false)"
                  class="px-4 py-1"
                  :to="{
                    name: 'services.single',
                    params: { id: 'it-sicherheit' },
                  }"
                  title="Leistung - IT Sicherheit"
                  ><span itemprop="name">IT-Sicherheit</span></router-link
                >
              </li>
              <li>
                <router-link
                  itemprop="url"
                  @click.native="setMobileMenuStatus(false)"
                  class="px-4 py-1"
                  :to="{
                    name: 'services.single',
                    params: { id: 'e-commerce' },
                  }"
                  title="Leistung - E-Commerce"
                  ><span itemprop="name">E-Commerce</span></router-link
                >
              </li>
              <li>
                <router-link
                  itemprop="url"
                  @click.native="setMobileMenuStatus(false)"
                  class="px-4 py-1"
                  :to="{
                    name: 'services.single',
                    params: { id: 'web-appentwicklung' },
                  }"
                  title="Leistung - App-/Webentwicklung"
                  ><span itemprop="name">Web-/Appentwicklung</span></router-link
                >
              </li>
            </ul>
          </li>
          <li class="position-relative my-4 my-lg-0">
            <router-link
              itemprop="url"
              @click.native="setMobileMenuStatus(false)"
              class="px-4 py-1"
              :to="{ name: 'projects' }"
              title="ito Projekte"
              ><span itemprop="name">Projekte</span></router-link
            >
          </li>
          <li class="position-relative my-4 my-lg-0">
            <router-link
              itemprop="url"
              @click.native="setMobileMenuStatus(false)"
              class="px-4 py-1"
              :to="{ name: 'jobs' }"
              title="Jobs bei ito"
              ><span itemprop="name">Jobs</span></router-link
            >
          </li>
          <li class="position-relative my-4 my-lg-0">
            <router-link
              itemprop="url"
              @click.native="setMobileMenuStatus(false)"
              class="btn btn-outline-ito ms-2 px-4 py-1"
              :to="{ name: 'contact' }"
              title="Kontakt und Anschrift"
              ><span itemprop="name">Kontakt</span></router-link
            >
          </li>
        </ul>
      </nav>
      <a
        class="toggleMenu burger d-lg-none ms-auto"
        :class="{ is_active: mobileMenuStatus }"
        @click="setMobileMenuStatus(!mobileMenuStatus)"
      >
        <span class="innerBurger"></span>
      </a>
    </div>
  </header>
</template>
<script>
export default {
  name: "MainHeader",
  props: {
    currentRoute: String,
  },
  data: function () {
    return {
      headerDown: false,
      headerUp: false,
      headerSmall: false,
      lastScroll: 0,
    };
  },
  computed: {
    mobileMenuStatus() {
      return this.$store.getters.mobileMenuStatus;
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // close mobile menu even on click on same route
    setMobileMenuStatus(status) {
      this.$store.commit("mobileMenuStatus", status);
    },
    handleScroll(event) {
      var a = window.pageYOffset;
      a > 5 ? (this.headerDown = true) : (this.headerDown = false);
      a > 150 ? (this.headerSmall = true) : (this.headerSmall = false);
      a > this.lastScroll && a > 200
        ? (this.headerUp = true)
        : (this.headerUp = false);
      this.lastScroll = a;
    },
  },
};
</script>
<style>
.toggleMenu {
  cursor: pointer;
}
</style>
